import {
    CircularProgress,
    Collapse,
    Dialog,
    DialogContent,
    Typography
} from "@mui/material";
import { useContext, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { ColorScheme } from "../../Themes/ColorScheme";
import { ApiContext } from "../ApiContext";
import BigButton from "../Common/BigButton";
import OnOffSlider from "../Common/OnOffSlider";
import { TextfieldPicker } from "../Common/TextfieldPicker";

import { ReactComponent as RestrictionStartIcon } from "../../Assets/Icons/TimeStartIcon.svg";

const Day = ({ day, openingHour, setOpeningHour }) => {
    const { t } = useTranslation();

    const changeOpeningHour = (time, type) => {
        const updatedOpeningHour = {
            ...openingHour,
            [type]: new Date(time).toISOString(),
            open_full: false,
        };
        console.log(updatedOpeningHour);
        setOpeningHour(updatedOpeningHour);
    }


    return (
        <div style={{flexDirection: "row", alignItems: "center", padding: "10px 0"}}>
            <Typography style={{ width: "50%", fontWeight: "bold" }}>
                {day.name}
            </Typography>
            <div style={{flexDirection: "row", display: "flex", width: "100%", alignItems: "center"}}>
            <TextfieldPicker 
                    hideClearButton={true}
                    removeIcon={true}
                    fullDate={false}
                    value={openingHour?.opens || "2020-01-01T00:00:00Z"}
                    excludePast={false}
                    label={t("doors.opens")}
                    valueChange={(value) => changeOpeningHour(value, "opens")}
                    hasProps={
                        <RestrictionStartIcon
                            stroke={ColorScheme.darkGrey}
                        />
                    }/>
                <div style={{width: 50}}></div>
                <TextfieldPicker 
                    hideClearButton={true}
                    removeIcon={true}
                    fullDate={false}
                    value={openingHour?.closes || "2020-01-01T00:00:00Z"}
                    excludePast={false}
                    label={t("doors.closes")}
                    valueChange={(value) => changeOpeningHour(value, "closes")}
                    hasProps={
                        <RestrictionStartIcon
                            stroke={ColorScheme.darkGrey}
                        />
                    }/>
            </div>
        </div>
    );
};

const OpeningHourDialog = ({
    door,
    dialogOpen,
    closeDialog,
}) => {
    const { ApiCall } = useContext(ApiContext);

    const [loading, setLoading] = useState(false);
    const [openingHours, setOpeningHours] = useState([]);

    const { t } = useTranslation();

    const [weekDays, setWeekDays] = useState([
        {
            index: 1,
            name: t("dates.monday_long"),
        },
        {
            index: 2,
            name: t("dates.tuesday_long"),
        },
        {
            index: 3,
            name: t("dates.wednesday_long"),
        },
        {
            index: 4,
            name: t("dates.thursday_long"),
        },
        {
            index: 5,
            name: t("dates.friday_long"),
        },
        {
            index: 6,
            name: t("dates.saturday_long"),
        },
        {
            index: 0,
            name: t("dates.sunday_long"),
        }
    ]);

    const [restrictTimes, setRestrictTimes] = useState(false);

    const handleClose = () => {
        closeDialog();
    };

    async function fetchData() {
        setLoading(true);
        ApiCall("GET", `client/door/opening_hours/${door.id}`)
            .then((response) => {
                setOpeningHours(response);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                console.log(error);
            });
    }

    const saveOpeningHours = () => {
        setLoading(true);
        // Remove the "id" and "door_id" fields from each opening hour object
        const openingHoursToSave = openingHours.map((hour) => {
            const { id, door_id, ...rest } = hour;
            return rest;
        });

        ApiCall("PUT", `client/door/opening_hours/${door.id}`, openingHoursToSave)
            .then(() => {
                setLoading(false);
                closeDialog();
            })
            .catch((error) => {
                setLoading(false);
                console.log(error);
            });
    };

    const changeOpeningHour = (openingHour) => {
        const updatedOpeningHours = openingHours.map((hour) => {
            if (hour.weekday === openingHour.weekday) {
                return {
                    ...hour,
                    open_full: openingHour.open_full,
                    opens: openingHour.opens,
                    closes: openingHour.closes,
                };
            }
            return hour;
        });
        setOpeningHours(updatedOpeningHours);
    }

    useEffect(() => {
        if (open) {
            fetchData();
        } else {
            setOpeningHours([]);
            setLoading(true);
        }
    }, [open]);

    useEffect(() => {
        if (!loading) {
            let openAllDays = true;
            for (let i = 0; i < weekDays.length; i++) {
                const day = weekDays[i];
                const openingHour = openingHours.find(
                    (hour) => hour.weekday === day.index
                ); 
                if (!openingHour) {
                    openAllDays = false;
                    break;
                }
                else if (!openingHour.open_full) {
                    openAllDays = false;
                    break;
                }
            }
            if (openAllDays) {
                setRestrictTimes(false);
            } else {
                setRestrictTimes(true);
            }
        }
    }, [loading]);

    useEffect(() => {
        if (!restrictTimes) {
            // Set all days to open full day
            const updatedOpeningHours = weekDays.map((day) => ({
                weekday: day.index,
                open_full: true,
                opens: "2020-01-01T00:00:00Z",
                closes: "2020-01-01T00:00:00Z",
            }));

            setOpeningHours(updatedOpeningHours);
        }
    }, [restrictTimes]);

    return (
        <div>
            <Dialog open={dialogOpen} onClose={handleClose}>
                <div style={{ width: "90vw", maxWidth: "500px" }}>
                    <DialogContent sx={{flex: 1}}>
                        <div style={{flexDirection: "row", display: "flex", alignItems: "center", justifyContent: "space-between", flex: 1}}>
                            <div>
                                <Typography style={{fontSize: "20px", fontWeight: "700"}}>{door.name}</Typography>
                                <Typography style={{ fontSize: "14px", marginTop: "10px", marginTop: "-5px" }}>
                                    {t("doors.opening_hours")}
                                </Typography>
                            </div>
                            <OnOffSlider helperText={"Rajoita aukioloaikoja"} status={restrictTimes} action={setRestrictTimes}></OnOffSlider>
                        </div>
                        {loading && <CircularProgress />}
                        {!loading && (
                            <Collapse in={restrictTimes} timeout={500}>
                               {weekDays.map((day) => {
                                    const openingHour = openingHours.find(
                                        (hour) => hour.weekday === day.index
                                    );
                                    return (
                                        <Day key={day} day={day} openingHour={openingHour ? openingHour : null} setOpeningHour={changeOpeningHour} />
                                    );
                                }
                                )}
                            </Collapse>
                        )}
                    </DialogContent>
                </div>
                <div style={{flexDirection: "row", display: "flex", flex: 1, padding: "20px", justifyContent: "space-between"}}>
                    <BigButton 
                        text={t("buttons.cancel")} 
                        activity={false}
                        borderColor={ColorScheme.buttonPrimary}
                        backgroundColor={ColorScheme.buttonSecondary}
                        textColor={ColorScheme.buttonSecondaryText}
                        action={closeDialog}
                        width={"47%"}
                    />
                     <BigButton 
                        text={t("buttons.save")} 
                        activity={loading}
                        borderColor={ColorScheme.buttonPrimary}
                        backgroundColor={ColorScheme.buttonPrimary}
                        textColor={ColorScheme.buttonPrimaryText}
                        action={saveOpeningHours}
                        width={"47%"}
                    />
                </div>
            </Dialog>
        </div>
    );
};

export default OpeningHourDialog;
